import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

export const LogsListApi = (data) => {
    const clubId = data.club_id || data.params?.club_id
    const url = URL.LOGS_LIST(clubId)
    
    const { club_id: clubIdParam, ...paramsWithoutClubId } = data
    
    return API.getV2Logs(url, paramsWithoutClubId)
}